module.exports = __webpack_public_path__ + "img/engine-icon.6cdfb85f.png";